import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from 'components/FormError';
import InputField from 'components/InputField';
import SelectSearchField from 'components/SelectSearchField';

import styles from './styles.module.scss';
import { isBlank } from 'helpers/validators';

let MassAccountChangeForm = ({ handleSubmit, error, simoAccounts }) => {
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.inputs}>
        <Field
          component={InputField}
          name="device_sns"
          label="Device SNs*"
          subText="Comma separated list. Ex.: abc0000d0efgh00i,abc0000d0efgh01i"
        />
        <Field
          component={SelectSearchField}
          name="new_account_id"
          label="New Account*"
          options={simoAccounts.map((account) => ({
            name: account.name,
            value: account.id,
          }))}
          placeholder="Select simo account"
          hideEmptyWhenHasValue={true}
          formName="massAccountChangeForm"
        />
      </div>
      {error && <FormError error={error} />}
      <button className="btn btn-primary">Mass Change Account</button>
    </form>
  );
};

const validate = (values) => {
  let errors = {};

  if (isBlank(values.device_sns)) {
    errors.device_sns = 'Required';
  }
  if (!values.new_account_id) {
    errors.new_account_id = 'Required';
  }

  return errors;
};

MassAccountChangeForm = reduxForm({
  form: 'massAccountChangeForm',
  validate,
})(MassAccountChangeForm);

export default MassAccountChangeForm;
